import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";

const links = [
  { label: "Work", to: "/#portfolio" },
  { label: "Packages", to: "/#packages" },
  { label: "Manifesto", to: "/#manifesto" },
  { label: "Contact", to: "/#booking" },
];

export default function Header() {
  const loc = useLocation();
  const dark = loc.pathname.startsWith("/admin");
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-40 backdrop-blur-xl ${dark ? "bg-black/50 border-b border-white/10 text-[#FDFBF7]" : "bg-[#FDFBF7]/70 border-b border-black/5 text-[#0A0A0A]"}`}
      data-testid="site-header"
    >
      <div className="max-w-[1440px] mx-auto flex items-center justify-between px-6 md:px-10 py-4">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
          <img
            src="https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/k7zd921i_IMG_3882.png"
            alt="Making Memories logo"
            className="h-9 md:h-11 w-auto object-contain"
          />
          <span className="font-serif text-lg md:text-xl tracking-tight leading-none hidden sm:inline">
            Photo Booth <em className="not-italic text-[#FF5722]">Memories</em>
          </span>
          <span className="overline hidden md:inline ml-2 opacity-70">L.L.C</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              className="text-sm tracking-wide hover:text-[#FF5722] transition-colors relative"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="/#booking"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#0A0A0A] text-[#FDFBF7] text-sm tracking-wide hover:bg-[#FF5722] transition-colors"
          data-testid="book-now-btn"
        >
          Book now
          <span className="w-1.5 h-1.5 rounded-full bg-[#FDFBF7]" />
        </a>
      </div>
    </motion.header>
  );
}
